export default __webpack_public_path__ + "static/media/social.1c723f81.svg";